// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"347":"15ea0597","499":"01380115","502":"15ea0597","531":"b1ee4ce9","618":"a05f973d","690":"a381d35f","843":"15ea0597"}[chunkId] + ".chunk.css";
};